import { Component, EventEmitter, inject, Inject, Input, OnInit, Output } from '@angular/core';
import { IonRouterOutlet, ModalController } from '@ionic/angular';
import { Tie } from '../../../../_shared/models/tie.model';
import { TrackersComponent } from '../../../../_shared/components/trackers/trackers.component';
import { TieDetailsService } from '../../tie-details.service';
import { ThemeService } from '../../../../_core/services/theme.service';

@Component({
  standalone: false,
    selector: 'app-tie-bar',
    templateUrl: './tie-bar.component.html',
    styleUrls: ['./tie-bar.component.scss'],
})
export class TieBarComponent implements OnInit {
    @Input() tie: Tie;
    @Output() openMenu = new EventEmitter();
    isOwner: boolean;
    isOfficial: boolean;
    themeService = inject(ThemeService);

    constructor(
        private modalController: ModalController,
        private routerOutlet: IonRouterOutlet,
        private tieDetailsService: TieDetailsService
    ) { }

    async ngOnInit() {
        this.isOwner = await this.tieDetailsService.isOwner(this.tie);
        this.isOfficial = await this.tieDetailsService.isOfficial(this.tie);
    }

    async showMoreOptions() {
        this.openMenu.emit();
    }

    async viewTrackers() {
        const modal = await this.modalController.create({
            component: TrackersComponent,
            componentProps: {
                tie: this.tie
            },
            presentingElement: this.routerOutlet.nativeEl
        });

        await modal.present();
    }

}
